import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faAngleLeft, faAngleRight, faBars, faXmark,
  faHouse, faCompassDrafting, faWifi, faEye, faKitchenSet,
  faWaterLadder, faDoorOpen, faTree, faHouseFloodWater,
  faChevronLeft, faChevronRight, faBed, faShower, faWater,
  faLocationDot, faPhone, faEnvelope, faArrowRight
} from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faInstagram, faTiktok } from '@fortawesome/free-brands-svg-icons'

library.add(
  faAngleLeft, faAngleRight, faBars, faXmark,
  faFacebook, faInstagram, faTiktok,
  faHouse, faCompassDrafting, faWifi, faEye, faKitchenSet,
  faWaterLadder, faDoorOpen, faTree, faHouseFloodWater,
  faChevronLeft, faChevronRight, faBed, faShower, faWater,
  faLocationDot, faPhone, faEnvelope, faArrowRight
);

const app = createApp(App);
app.component('font-awesome-icon', FontAwesomeIcon);

app.directive('reveal', {
  mounted(el, binding) {
    const delay = binding.value?.delay ?? 0;
    el.style.opacity = '0';
    el.style.transform = 'translateY(36px)';
    el.style.transition = `opacity 0.95s cubic-bezier(0.4,0,0.2,1) ${delay}ms, transform 0.95s cubic-bezier(0.4,0,0.2,1) ${delay}ms`;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
        obs.disconnect();
      }
    }, { threshold: 0.1 });
    obs.observe(el);
  }
});

// Usage: v-parallax="0.35"  (speed 0–1, default 0.35)
app.directive('parallax', {
  mounted(el, binding) {
    const speed: number = binding.value ?? 0.35;
    const update = () => {
      const rect = (el.parentElement ?? el).getBoundingClientRect();
      const offset = rect.top;
      el.style.transform = `translateY(${offset * speed}px)`;
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
    (el as any)._parallaxOff = () => window.removeEventListener('scroll', update);
  },
  unmounted(el) {
    (el as any)._parallaxOff?.();
  }
});

app.use(router);
app.mount('#app');
